import { ITimezone } from './vo/Timezone';

export const DEFAULT_TIME_ZONE: ITimezone = {
  id: '64953181-82fa-4413-9f94-0c47a4b2365b',
  timeZone: 'America/New_York',
  abbr: 'ET',
  name: 'New York',
  priorityCount: 0,
};

export const GMT0_TIME_ZONE: ITimezone = {
  id: '9f6a01a6-9124-4dd8-b659-d61ddabc6c59',
  timeZone: 'Europe/London',
  abbr: 'UKT',
  name: 'London',
  priorityCount: 0,
};

export const UTC_TIME_ZONE: ITimezone = {
  id: '4f6af4bd-300d-474b-b9a3-726d36beb8cd',
  timeZone: 'Etc/GMT',
  abbr: 'GMT',
  name: 'GMT (No Daylight Saving)',
  priorityCount: 0,
};
